import "core-js/modules/es.symbol";
import "core-js/modules/es.symbol.description";
import "core-js/modules/es.symbol.iterator";
import "core-js/modules/es.array.concat";
import "core-js/modules/es.array.filter";
import "core-js/modules/es.array.iterator";
import "core-js/modules/es.object.get-own-property-descriptor";
import "core-js/modules/es.object.get-prototype-of";
import "core-js/modules/es.object.keys";
import "core-js/modules/es.object.set-prototype-of";
import "core-js/modules/es.object.to-string";
import "core-js/modules/es.string.iterator";
import "core-js/modules/web.dom-collections.for-each";
import "core-js/modules/web.dom-collections.iterator";

function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; var ownKeys = Object.keys(source); if (typeof Object.getOwnPropertySymbols === 'function') { ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function (sym) { return Object.getOwnPropertyDescriptor(source, sym).enumerable; })); } ownKeys.forEach(function (key) { _defineProperty(target, key, source[key]); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

import PropTypes from 'prop-types';
import trackDwell from 'decorators/TrackDwell/TrackDwell';
import React, { Component } from 'react';
import Helmet from 'react-helmet';
import { bindActionCreators } from 'redux';
import { userActionCampaign } from 'redux/saga/entities/bound';
import { useReducedNavigation } from 'redux/modules/page';
import { deepExtract } from 'helpers/deep';
import { loadSaga } from './inviteAFriendHero.saga';
import { ClassAvailable } from './ClassAvailable';
import { ClassUnavailable } from './ClassUnavailable';
export var InviteAFriendHeroUnwrapped =
/*#__PURE__*/
function (_Component) {
  _inherits(InviteAFriendHeroUnwrapped, _Component);

  function InviteAFriendHeroUnwrapped() {
    _classCallCheck(this, InviteAFriendHeroUnwrapped);

    return _possibleConstructorReturn(this, _getPrototypeOf(InviteAFriendHeroUnwrapped).apply(this, arguments));
  }

  _createClass(InviteAFriendHeroUnwrapped, [{
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      this.props.useReducedNavigation(false);
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props = this.props,
          backgroundColor = _this$props.backgroundColor,
          baseUrl = _this$props.baseUrl,
          ctaText = _this$props.ctaText,
          legal = _this$props.legal,
          _this$props$referral = _this$props.referral,
          data = _this$props$referral.data,
          loaded = _this$props$referral.loaded,
          title = _this$props.title,
          subtitle = _this$props.subtitle,
          unavailableSubtitle = _this$props.unavailableSubtitle,
          unavailableTitle = _this$props.unavailableTitle;
      var availability = deepExtract('schedule.availability.status', data, '');
      var heroContent;

      if (!loaded) {
        return false;
      } else if (availability === 'available') {
        heroContent = React.createElement(ClassAvailable, {
          ctaText: ctaText,
          displayName: deepExtract('referrer.display_name', data),
          legal: legal,
          purchaseUrl: data.purchase_url,
          schedule: data.schedule,
          subtitle: subtitle,
          title: title
        });
      } else if (availability === 'unavailable') {
        heroContent = React.createElement(ClassUnavailable, {
          ctaText: ctaText,
          displayName: deepExtract('referrer.display_name', data, ''),
          legal: legal,
          purchaseUrl: data.purchase_url,
          subtitle: unavailableSubtitle,
          title: unavailableTitle,
          venueName: deepExtract('schedule.venue.name', data, '')
        });
      } else {
        heroContent = React.createElement(ClassUnavailable, {
          ctaText: "See Plans",
          purchaseUrl: "/pricing",
          subtitle: "Unfortunately, this promotion is no longer valid. Please double check with your friend for an up-to-date invite code.",
          title: "Oh no! This promotion is no longer valid."
        });
      }

      var imageUrl = deepExtract('schedule.venue.images.default', data);
      return React.createElement("div", {
        className: "invite-a-friend-hero bg--".concat(backgroundColor)
      }, React.createElement(Helmet, {
        title: "ClassPass | You are Invited",
        meta: [{
          property: 'og:url',
          content: "".concat(baseUrl, "invite")
        }, {
          property: 'og:image',
          content: imageUrl
        }, {
          name: 'robots',
          content: 'noindex'
        }]
      }), React.createElement("div", {
        className: "wrap wrap--narrow"
      }, heroContent));
    }
  }]);

  return InviteAFriendHeroUnwrapped;
}(Component);

InviteAFriendHeroUnwrapped.propMapper = function (state, moduleDef) {
  return {
    backgroundColor: moduleDef.backgroundColor,
    baseUrl: state.request.baseUrl,
    ctaText: moduleDef.ctaText,
    legal: moduleDef.legal,
    referral: userActionCampaign.select(state, userActionCampaign.lastRequestedKey(state)),
    subtitle: moduleDef.subtitle,
    title: moduleDef.title,
    unavailableSubtitle: moduleDef.unavailableSubtitle,
    unavailableTitle: moduleDef.unavailableTitle
  };
};

InviteAFriendHeroUnwrapped.handlerMapper = function (dispatch) {
  return _objectSpread({
    dispatch: dispatch
  }, bindActionCreators({
    useReducedNavigation: useReducedNavigation
  }, dispatch));
};

InviteAFriendHeroUnwrapped.propTypes = {
  backgroundColor: PropTypes.oneOf(['light', 'white']),
  baseUrl: PropTypes.string.isRequired,
  ctaText: PropTypes.string.isRequired,
  legal: PropTypes.string,
  referral: PropTypes.object,
  subtitle: PropTypes.string,
  title: PropTypes.string.isRequired,
  unavailableSubtitle: PropTypes.string,
  unavailableTitle: PropTypes.string.isRequired,
  useReducedNavigation: PropTypes.func.isRequired
};
InviteAFriendHeroUnwrapped.loadSaga = loadSaga;
export var InviteAFriendHero = trackDwell(InviteAFriendHeroUnwrapped);